import { Keyper as keyper } from "./lib/keyper";
window.keyper = keyper;
export * from "./lib/types";
export { keyper };
keyper.watch({
    useRemote: true
});
//# sourceMappingURL=index.js.map